// src/pages/admin/users/UsersTable.jsx
import { useEffect, useMemo, useState } from "react";
import {
  Table,
  Input,
  Button,
  Modal,
  Descriptions,
  Tag,
  Space,
  Typography,
  Image,
  message,
} from "antd";
import axios from "../../../requests/axios";
import routes from "../../../requests/routes";
import TableWithExport from "../../../generic components/TableWithExport/TableWithExport";
import {
  getName,
  getEmail,
  getPhone,
  getCreated,
  fmtDate,
} from "../../../generic components/TableWithExport/TableWithExport.utils";
const { Text } = Typography;

export const NewsLetter = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState(null);

  const fetchNewsLetter = async () => {
    try {
      setLoading(true);
      const res = await axios.get(routes.newsLetter);
      const list = res?.data?.subscribers || res?.data || [];
      setData(Array.isArray(list) ? list : []);
    } catch (e) {
      console.error("Users fetch error:", e?.message);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNewsLetter();
  }, []);

  const columns = [
    { title: "#", width: 64, align: "center", render: (_v, _r, i) => i + 1 },
    {
      title: "Name",
      sorter: (a, b) => getName(a).localeCompare(getName(b)),
      render: (_, r) => <Text strong>{getName(r) || "—"}</Text>,
    },
    {
      title: "Email",
      sorter: (a, b) => getEmail(a).localeCompare(getEmail(b)),
      render: (_, r) => <Text copyable>{getEmail(r) || "—"}</Text>,
    },
    {
      title: "Phone",
      responsive: ["md"],
      render: (_, r) => getPhone(r) || "—",
    },
    {
      title: "Created",
      width: 200,
      sorter: (a, b) =>
        new Date(getCreated(a) || 0) - new Date(getCreated(b) || 0),
      render: (_, r) => fmtDate(getCreated(r)),
    },
    {
      title: "Actions",
      fixed: "right",
      width: 120,
      render: (_, record) => (
        <Space>
          <Button
            type="link"
            onClick={() => {
              setCurrent(record);
              setOpen(true);
            }}
          >
            Show
          </Button>
          <Button
            danger
            type="link"
            onClick={() => {
              Modal.confirm({
                title: "Delete subscriber",
                content: "Are you sure you want to delete this subscriber?",
                okText: "Delete",
                okType: "danger",
                cancelText: "Cancel",
                onOk: async () => {
                  try {
                    await axios.delete(routes.deleteNewsletter(record._id));
                    message.success("Subscriber deleted");
                    fetchNewsLetter();
                  } catch (e) {
                    message.error("Failed to delete subscriber");
                  }
                },
              });
            }}
          >
            Delete
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <h2 className="adminTitle">Newsletter</h2>

      <TableWithExport
        setCurrent={setCurrent}
        setOpen={setOpen}
        data={data}
        loading={loading}
        columns={columns}
        tableName={"newsletter"}
        filters={false}
      />

      <Modal
        open={open}
        title={getName(current) || "User details"}
        onCancel={() => setOpen(false)}
        width={720}
        footer={[
          <Button key="submit" type="primary" onClick={() => setOpen(false)}>
            Done
          </Button>,
        ]}
      >
        {current && (
          <Descriptions column={1} size="middle" colon>
            <Descriptions.Item label="Email">
              <Text copyable>{getName(current)}</Text>
            </Descriptions.Item>
            <Descriptions.Item label="Phone">
              <Text copyable>{getPhone(current)}</Text>
            </Descriptions.Item>
            <Descriptions.Item label="Email">
              <Text copyable>{getEmail(current)}</Text>
            </Descriptions.Item>

            <Descriptions.Item label="Created at">
              {fmtDate(getCreated(current))}
            </Descriptions.Item>
          </Descriptions>
        )}
      </Modal>
    </div>
  );
};

export default NewsLetter;
